/**
 * ProfileService by karora on 20/03/17.
 */
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

import { StandardResponse } from '../types/standard-response';
import { SocialProfile, UserProfile } from '../types/user-profile';
import { ApiService } from './api.service';
import { HubService } from './hub.service';

export const ProfileTypeGoogle = 1;

@Injectable()
export class ProfileService {
  private static userProfile: UserProfile;
  private static sessionCookie: string;

  private static handleProfileResponse(response: StandardResponse): UserProfile {
    try {
      let status = response && response.status;
      if (status === 'success' && response.data) {
        ProfileService.userProfile = response.data;
        let currentUser = JSON.parse(localStorage.getItem('currentUser'));
        currentUser.profile = response.data;
        localStorage.setItem('currentUser', JSON.stringify(currentUser));
        ApiService.LoginSuccessful();
      }
    } catch (e) {
      console.log('Error getting user profile :-(');
    }
    return ProfileService.userProfile;
  }

  static getCookieValue(a: string): string {
    let b = document.cookie.match('(^|;)\\s*' + a + '\\s*=\\s*([^;]+)');
    return b ? b.pop() : '';
  }

  public static CanAdminister(): boolean  {
    try {
      if (ProfileService.userProfile && ProfileService.userProfile.id) {
        return ProfileService.userProfile.administer;
      }
    } catch (e) {
      console.log(e.message);
    }
    return false;
  }

  public static HasRight(right: string): boolean  {
    try {
      if (ProfileService.userProfile && ProfileService.userProfile.id && ProfileService.userProfile.rights) {
        return !!ProfileService.userProfile.rights[right];
      }
    } catch (e) {
      console.log(e.message);
    }
    return false;
  }

  static logout(): void {
    // clear token remove user from local storage to log user out
    ApiService.AuthenticationExpired();
    ProfileService.userProfile = null;
  }

  constructor(private api: ApiService) {
    ProfileService.sessionCookie = ProfileService.getCookieValue('HUBSession');
    // set token if saved in local storage
    ProfileService.userProfile = <UserProfile>{
      'id': '',
      'name': 'unknown',
      'email': '',
      'administer': false,
      'rights': {},
      'social': <SocialProfile>{
        'id': '',
        'email': '',
        'verified_email': '',
        'name': 'unknown',
        'given_name': '',
        'family_name': '',
        'locale': '',
        'picture': '',
      },
      'type': 0,
    };
    try {
      let currentUser = JSON.parse(localStorage.getItem('currentUser'));
      if (currentUser) {
        ProfileService.userProfile = currentUser.profile;
      }
    } catch (e) {}
  }

  GetProfile(): Observable<UserProfile> {
    return this.api.Get('/auth/profile').pipe(
      map(ProfileService.handleProfileResponse)
    );
  }

  AllProfiles(): Observable<UserProfile[]> {
    console.log('Getting Profiles');
    return this.api.Get(ApiService.AdminBaseURL + `profiles/all`).pipe(
      map(response => response.list as UserProfile[]),
      catchError(HubService.LogFetchError)
    );
  }

  OneProfile(type: number, id: string): Observable<UserProfile> {
    console.log('Getting Profile type ' + type + ', ID: ' + id);
    return this.api.Get(ApiService.AdminBaseURL + `profile/${type}/${id}`).pipe(
      map((response: StandardResponse) => response.data as UserProfile),
      catchError(HubService.LogFetchError)
    );
  }

  UpdateProfile(profile: UserProfile): Observable<StandardResponse> {
    console.log('Updating Profile type ' + profile.type + ', ID: ' + profile.id);
    return this.api.Put(ApiService.AdminBaseURL + `profile/${profile.type}/${profile.id}`, profile);
  }

}
